import { schema } from 'normalizr'
import {
  createEntitiesSelector,
  createSelectorForEntityKey,
  actionCrudCreatorsFor,
} from '@infotech/lib-api-middleware'
import { TOIR_CORE_URL } from './constants'

export const TOIR_ISSUES_SCHEMA_NAME = `toirIssues`
export const URL = `${TOIR_CORE_URL}/core/issues`

const toirIssuesSchema = new schema.Entity(TOIR_ISSUES_SCHEMA_NAME)
export const toirIssuesSelector = createSelectorForEntityKey(TOIR_ISSUES_SCHEMA_NAME)
export const toirIssuesEntitiesSelector = createEntitiesSelector(TOIR_ISSUES_SCHEMA_NAME)
export const toirIssuesApiActions = actionCrudCreatorsFor(TOIR_ISSUES_SCHEMA_NAME, URL, toirIssuesSchema)
